<template>
  <el-dropdown @command="handleCommand">
    <el-button type="primary" class="btn" size="mini">
      Clone
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-if="currentRouteName==routePO" command="po">Order</el-dropdown-item>
      <el-dropdown-item command="inv">{{invName}}</el-dropdown-item>
      <el-dropdown-item command="cn">{{bcnName}}</el-dropdown-item>
      <el-dropdown-item v-if="currentRouteName==routeBL" command="b2inv">Bill -> Invoice</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapActions } from 'vuex'
import { routeINV, routeCN, routePO, routeBL, routeBCN } from '../router'
export default {
  name: 'BtnClone',
  computed: {
    currentRouteName () {
      return this.$route.params.routeName
    },
    invName () {
      return this.currentRouteName === routeINV || this.currentRouteName === routeCN ? 'Invoice' : 'Bill'
    },
    bcnName () {
      return this.currentRouteName === routeINV || this.currentRouteName === routeCN ? 'Credit Note' : 'Bill Credit Note'
    }
  },
  data () {
    return {
      routePO: routePO,
      routeBL: routeBL
    }
  },
  methods: {
    ...mapActions({
      clone: 'edit/cloneTo',
      cloneBillToInv: 'edit/cloneBillToInv'
    }),
    handleCommand (command) {
      if (command === 'inv') {
        if (
          this.currentRouteName === routeINV ||
          this.currentRouteName === routeCN
        ) {
          this.$router.push({
            name: 'OrderAdd',
            params: { routeName: routeINV, operation: 'clone' }
          })
        } else {
          this.$router.push({
            name: 'OrderAdd',
            params: { routeName: routeBL, operation: 'clone' }
          })
        }
      } else if (command === 'po') {
        this.$router.push({
          name: 'OrderAdd',
          params: { routeName: routePO, operation: 'clone' }
        })
      } else if (command === 'b2inv') {
        this.$router.push({
          name: 'OrderAdd',
          params: { routeName: routeINV, operation: 'cloneBillToInv' }
        })
      } else {
        if (
          this.currentRouteName === routeINV ||
          this.currentRouteName === routeCN
        ) {
          this.$router.push({
            name: 'OrderAdd',
            params: { routeName: routeCN, operation: 'clone' }
          })
        } else {
          this.$router.push({
            name: 'OrderAdd',
            params: { routeName: routeBCN, operation: 'clone' }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: #32c5d2;
  border-color: #32c5d2;
  margin-left: 10px;
}
.btn:hover,
.btn:focus {
  background-color: #46d2df;
  border-color: #46d2df;
}
</style>
